import { jwtRoutes } from './jwt';

export const authRoutes = [
  {
    path: 'auth',
    children: jwtRoutes,
  },
];
